export const classForExcludingFromRichEditorRules = 'skip-rich-text';
export const richTextContainerClass =
  'rich-container [&>.rte-sub]:my-10 [&>.rte-sub:last-child]:mb-0';
